const SUBSCRIPTION_INTENT_KEY = "subscription_intent";

export function setSubscriptionIntent(value: string): void {
  localStorage.setItem(SUBSCRIPTION_INTENT_KEY, value);
}

export function getSubscriptionIntent(): string | null {
  return localStorage.getItem(SUBSCRIPTION_INTENT_KEY);
}

export function clearSubscriptionIntent(): void {
  localStorage.removeItem(SUBSCRIPTION_INTENT_KEY);
}
